import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import {
    DEFAULT_COLUMN,
    DEFAULT_TOURIST_COLUMN,
    DEFAULT_VA_COLUMN,
    SALES_FORECAST_MODULE,
} from "../constant/salesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const forecastColumns = (): Column[] => {
    if (subDomain === 'valeurs-assurances') return DEFAULT_VA_COLUMN;
    if (subDomain === 'tourist-forum') return DEFAULT_TOURIST_COLUMN;
    return DEFAULT_COLUMN;
};

export const setSalesReceiptForecastPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SALES_FORECAST_MODULE,
        default_columns: forecastColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
